/* eslint-disable no-trailing-spaces */
import LineTool from './LineTool';

/** A line with customizable arrowheads */
class ArrowLineTool extends LineTool {
	/**
	 * Retrieves default parameters for tool, including details and styles
	 * @return {Object} Object containing default tool parameters
	 * @property {String} id - Tool ID
	 * @property {String} name - Tool name
	 * @property {Boolean} arrow - Flag to determine if line should be arrow
	 * @property {Object} style - Tool styles
	 */
	_getDefaultParams() {
		return {
			id: 'arrow',
			name: 'Arrow',
			arrow: true,
			style: this.core.getStyle('tool.arrow')
		};
	}

	/**
	 * Draws arrowheads for tool
	 * @param {CanvasRenderingContext2D} ctx - HTML canvas context to be used for drawing graphics
	 * @param {Number} x1 - First x-coordinate of line
	 * @param {Number} y1 - First y-coordinate of line
	 * @param {Number} x2 - Second x-coordinate of line
	 * @param {Number} y2 - Second x-coordinate of line
	 */
	drawArrowheads(ctx, x1, y1, x2, y2) {
		// draw the ending arrowhead
		let endRadians = Math.atan((y2 - y1) / (x2 - x1));
		endRadians += ((x2 >= x1 ? 90 : -90) * Math.PI) / 180;
		this.drawArrowhead(ctx, x2, y2, endRadians);
	}

	/**
	 * Draws a single arrowhead at the given coordinates
	 * @param {CanvasRenderingContext2D} ctx - HTML canvas context to be used for drawing graphics
	 * @param {Number} x - X-coordinate for point of arrow
	 * @param {Number} y - Y-coordinate for point of arrow
	 * @param {Number} radians - Angle at which to rotate the canvas to properly draw the lines of the arrowhead
	 */
	drawArrowhead(ctx, x, y, radians) {
		ctx.save();
		ctx.beginPath();
		ctx.translate(x, y);
		ctx.rotate(radians);
		ctx.moveTo(0, 0);
		ctx.lineTo(this.params.style.arrow.width, this.params.style.arrow.height);
		ctx.lineTo(
			-this.params.style.arrow.width,
			this.params.style.arrow.height
		);
		ctx.closePath();
		ctx.restore();
		ctx.fillStyle = this.params.style.background.color;
		ctx.fill();
	}
}
export default ArrowLineTool;
